import { Box, Container, Grid, Link, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface FooterLink {
	label: string;
	path: string;
}

const footerLinks: Record<string, FooterLink[]> = {
	Product: [
		{ label: "Features", path: "/features" },
		{ label: "Pricing", path: "/pricing" },
	],
	Company: [
		{ label: "About", path: "/about" },
		{ label: "Contact", path: "/contact" },
	],
	Legal: [
		{ label: "Privacy Policy", path: "/privacy" },
		{ label: "Terms of Service", path: "/terms" },
	],
};

export const PublicFooter = () => {
	const navigate = useNavigate();

	return (
		<Box
			component="footer"
			sx={{
				bgcolor: "background.paper",
				borderTop: "1px solid",
				borderColor: "divider",
				py: 8,
			}}
		>
			<Container maxWidth="lg">
				<Grid container spacing={4}>
					<Grid item xs={12} md={4}>
						<Typography
							variant="h6"
							sx={{
								fontWeight: 700,
								mb: 2,
								color: "text.primary",
							}}
						>
							NoMachine
						</Typography>
						<Typography
							variant="body2"
							sx={{
								color: "text.secondary",
								mb: 2,
							}}
						>
							Secure online forms that prevent responders to use AI, helping
							companies and universities reliably evaluate knowledge.
						</Typography>
					</Grid>

					{Object.entries(footerLinks).map(([category, links]) => (
						<Grid item xs={6} sm={4} md={2} key={category}>
							<Typography
								variant="subtitle2"
								sx={{
									fontWeight: 600,
									mb: 2,
									color: "text.primary",
								}}
							>
								{category}
							</Typography>
							<Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
								{links.map((link) => (
									<Link
										key={link.path}
										component="button"
										onClick={() => navigate(link.path)}
										sx={{
											color: "text.secondary",
											textDecoration: "none",
											fontSize: "0.875rem",
											textAlign: "left",
											border: "none",
											background: "transparent",
											padding: 0,
											cursor: "pointer",
											"&:hover": {
												color: "text.primary",
											},
										}}
									>
										{link.label}
									</Link>
								))}
							</Box>
						</Grid>
					))}
				</Grid>

				<Box
					sx={{
						mt: 6,
						pt: 4,
						borderTop: "1px solid",
						borderColor: "divider",
					}}
				>
					<Typography
						variant="body2"
						sx={{
							color: "text.secondary",
							textAlign: "center",
						}}
					>
						© {new Date().getFullYear()} NoMachine. All rights reserved.
					</Typography>
				</Box>
			</Container>
		</Box>
	);
};
